import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, FacebookIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
import { SITE, NAV } from '../lib/site';
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-30" data-mp="36pfs3rou7l34">
      <path d="M16.5 3c.3 2.1 1.6 3.8 3.6 4.1v2.6c-1.3.1-2.5-.3-3.6-1v5.6a5.7 5.7 0 1 1-5.7-5.7c.3 0 .6 0 .9.1v2.7a3 3 0 1 0 2.1 2.9V3h2.7Z" data-id="element-31" data-mp="36n3bpiyq9is6" />
    </svg>;
}
export function Footer() {
  return <footer className="border-t border-white/10 bg-black text-white" data-id="element-32" data-mp="36d3qyjl4vnu">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4" data-id="element-33" data-mp="3ldu3ir0bkhva">
        <div className="md:col-span-1" data-id="element-34" data-mp="3qc3zh3tvbmhy">
          <img src={SITE.logo} alt="Junk Kings free estimates and service information" className="h-auto w-full max-w-[270px] rounded object-cover object-center" data-id="element-35" data-mp="3qf9rorxsn4hw" />
          <p className="mt-4 text-sm text-white/60" data-id="element-36" data-mp="3l9k7bh9idvfe">
            Locally owned junk removal, hauling, and demo. Fast, friendly, and up-front — serving {SITE.area}.
          </p>
        </div>

        <div data-id="element-37" data-mp="3v7q63q00qlg1">
          <h3 className="font-display text-lg font-bold uppercase tracking-wide text-jk-red" data-id="element-38" data-mp="3v7ggw4mssibe">Explore</h3>
          <ul className="mt-4 space-y-2 text-sm" data-id="element-39" data-mp="3q83tnis0l98a">
            {NAV.map(item => <li key={item.to} data-id="element-40" data-mp="830gdarw9qws">
                <Link to={item.to} className="text-white/70 transition-colors hover:text-white" data-id="element-41" data-mp="81yx4j0q5y3z">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </div>

        <div data-id="element-42" data-mp="hrihjt43600y">
          <h3 className="font-display text-lg font-bold uppercase tracking-wide text-jk-red" data-id="element-43" data-mp="hs1xj4a6eecc">Get In Touch</h3>
          <ul className="mt-4 space-y-3 text-sm text-white/75" data-id="element-44" data-mp="cvto87intfd3">
            <li data-id="element-45" data-mp="quji7ea6myx8">
              <a href={SITE.phoneHref} className="flex items-center gap-2 hover:text-white" data-id="element-46" data-mp="qu1jmb01s8m5">
                <PhoneIcon className="h-4 w-4 text-jk-red" data-id="element-47" data-mp="mthjqzo3aqwb" /> {SITE.phoneDisplay}
              </a>
            </li>
            <li data-id="element-48" data-mp="twxrd9sgza9b">
              <a href={`mailto:${SITE.email}`} className="flex items-center gap-2 hover:text-white" data-id="element-49" data-mp="tt9zsg6l4xx8">
                <MailIcon className="h-4 w-4 text-jk-red" data-id="element-50" data-mp="13tammc3nxw66" /> {SITE.email}
              </a>
            </li>
            <li className="flex items-center gap-2" data-id="element-51" data-mp="18k0rlo86fx0c">
              <MapPinIcon className="h-4 w-4 text-jk-red" data-id="element-52" data-mp="18lk91i5kke3p" /> {SITE.area}
            </li>
            <li className="flex items-center gap-2" data-id="element-53" data-mp="1ckt0uhh1u1wm">
              <ClockIcon className="h-4 w-4 text-jk-red" data-id="element-54" data-mp="1hkp58htnrvcp" /> {SITE.hours}
            </li>
          </ul>
        </div>

        <div data-id="element-55" data-mp="1mj8uos7gnp9t">
          <h3 className="font-display text-lg font-bold uppercase tracking-wide text-jk-red" data-id="element-56" data-mp="1mjihk6x7lgba">Follow The Kings</h3>
          <div className="mt-4 flex gap-3" data-id="element-57" data-mp="1rhk4x41o41sk">
            {[{
            href: SITE.social.facebook,
            Icon: FacebookIcon,
            label: 'Facebook'
          }, {
            href: SITE.social.instagram,
            Icon: InstagramIcon,
            label: 'Instagram'
          }, {
            href: SITE.social.tiktok,
            Icon: TikTokIcon,
            label: 'TikTok'
          }, {
            href: SITE.social.youtube,
            Icon: YoutubeIcon,
            label: 'YouTube'
          }].map(({
            href,
            Icon,
            label
          }) => <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label} className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-white/15 text-white/80 transition-colors hover:border-jk-red hover:bg-jk-red hover:text-white" data-id="element-58" data-mp="25mkhizvt6khz">
                <Icon className="h-5 w-5" data-id="element-59" data-mp="2pa9wg6incq9s" />
              </a>)}
          </div>
          <a href={SITE.phoneHref} className="mt-6 inline-flex items-center gap-2 rounded-md bg-jk-red px-4 py-2.5 font-display text-lg font-bold uppercase tracking-wide text-white hover:bg-jk-redDark" data-id="element-60" data-mp="2kbgmgo2kjhed">
            <PhoneIcon className="h-4 w-4" data-id="element-61" data-mp="13zb7usiwplvq" /> Call Now
          </a>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-62" data-mp="2rvzltbb281sn">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-white/45 sm:flex-row sm:px-6" data-id="element-63" data-mp="2ru6dlrkst9ij">
          <p data-id="element-64" data-mp="2iv1ccdhur22o">© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <p data-id="element-65" data-mp="2isyifidkwoso">Fully insured · Free estimates · Same-day service available</p>
        </div>
      </div>
    </footer>;
}